// extracted by mini-css-extract-plugin
module.exports = {"row":"EventInfoRow_row__2IzEe","icon":"EventInfoRow_icon__1Hdhk"};